export class ContactInfoSubTypeResultDto {
  id: string;
  displayText: string;
}
